/**
 * Returns a promise that will resolve after the specified number of mills.
 *
 * For use only in exceptional circumstances!
 */
export const pause = (millis: number) =>
  new Promise(resolve => {
    setTimeout(resolve, millis);
  });
